var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bubble-preview" }, [
    _vm.getCustomBubbleIcon()
      ? _c("img", {
          style: { width: _vm.width, height: _vm.height },
          attrs: { alt: "bubble", src: _vm.getCustomBubbleIcon() },
          on: {
            click: function ($event) {
              return _vm.$bvModal.show("bubble-icon-modal")
            },
          },
        })
      : _c(
          "div",
          {
            on: {
              click: function ($event) {
                return _vm.$bvModal.show("bubble-icon-modal")
              },
            },
          },
          [
            _vm.settings.bubble.preDefined === "1"
              ? _c("Bubble1", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "2"
              ? _c("Bubble2", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "3"
              ? _c("Bubble3", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "4"
              ? _c("Bubble4", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "5"
              ? _c("Bubble5", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "6"
              ? _c("Bubble6", {
                  style: { width: _vm.width, height: _vm.height },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "7"
              ? _c("Bubble7", {
                  staticStyle: {
                    width: "155px",
                    height: "50px",
                    "object-fit": "contain",
                  },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.bubble.preDefined === "8"
              ? _c("Bubble8", {
                  staticStyle: {
                    width: "155px",
                    height: "50px",
                    "object-fit": "contain",
                  },
                  attrs: { color: _vm.settings.bubble.bubbleColor },
                })
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }